module.exports = __webpack_public_path__ + "img/grad-2.c0d927a8.svg";